import type { JSX } from "react";
import { useNavigate } from "react-router";
import { Card, CardContent } from "@/ui/card.js";
import {
  ADD_RECIPE_OPTIONS,
  addRecipeTarget,
  type AddRecipeOption,
} from "../../features/imports/addRecipeOptions.js";

export function NewDispatch(): JSX.Element {
  const navigate = useNavigate();

  function go(key: AddRecipeOption["key"]): void {
    void navigate(addRecipeTarget(key));
  }

  return (
    <div className="mx-auto max-w-xl px-4 py-6 space-y-4">
      <h1 className="text-2xl font-semibold">New recipe</h1>
      <p className="text-sm text-muted-foreground">
        Pick how you want to add this recipe.
      </p>
      <ul className="space-y-3">
        {ADD_RECIPE_OPTIONS.map((opt) => (
          <li key={opt.key}>
            <Card
              role="button"
              tabIndex={0}
              onClick={() => go(opt.key)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") go(opt.key);
              }}
              className="cursor-pointer transition-colors hover:border-primary focus:border-primary"
            >
              <CardContent className="flex items-center gap-4 py-4">
                <span className="text-3xl" aria-hidden>
                  {opt.icon}
                </span>
                <div>
                  <p className="font-medium">{opt.title}</p>
                  <p className="text-sm text-muted-foreground">{opt.subtitle}</p>
                </div>
              </CardContent>
            </Card>
          </li>
        ))}
      </ul>
    </div>
  );
}
